import { Outlet, NavLink, useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/toaster";
import HRlogo from "@/assets/HRlogo.png";

export default function RootLayout() {
  const { user, isAuthenticated, isLoading, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has super_admin role - role property is optional so use optional chaining
  const isSuperAdmin = user?.role === 'super_admin';

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b">
        <div className="container mx-auto flex items-center gap-4 h-14">
          <NavLink to="/" className="flex items-center">
            <img src={HRlogo} alt="HRO Logo" className="h-12 w-12" />
            <span className="font-bold text-xl">Militech HR</span>
          </NavLink>
          
          <nav className="flex items-center gap-4">
            
            <NavLink 
              to="/talent-pool" 
              className={({ isActive }) => 
                `text-sm hover:underline ${isActive ? 'font-bold' : ''}`
              }
            >
              Talent Pool
            </NavLink>
            
            <NavLink 
              to="/resource-requests" 
              className={({ isActive }) => 
                `text-sm hover:underline ${isActive ? 'font-bold' : ''}`
              }
            >
             Resource Request
            </NavLink>
            
            <NavLink 
              to="/pipeline" 
              className={({ isActive }) => 
                `text-sm hover:underline ${isActive ? 'font-bold' : ''}`
              }
            >
              Pipeline <span className="inline-flex items-center justify-center ml-1 px-1.5 py-0.5 text-xs font-medium rounded bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-500">Demo</span>
            </NavLink>
            
            <NavLink 
              to="/reports" 
              className={({ isActive }) => 
                `text-sm hover:underline ${isActive ? 'font-bold' : ''}`
              }
            >
              Reports <span className="inline-flex items-center justify-center ml-1 px-1.5 py-0.5 text-xs font-medium rounded bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-500">Demo</span>
            </NavLink>
            {/* Show User Management link only for super admin */}
            {isSuperAdmin && (
              <NavLink 
                to="/users" 
                className={({ isActive }) => 
                  `text-sm hover:underline ${isActive ? 'font-bold' : ''}`
                }
              >
                User Management
              </NavLink>
            )}
          </nav>

          <div className="flex-1"></div>

          <div className="flex items-center">
            {isAuthenticated ? (
              <>
                <span className="text-sm mr-2">
                  Hello, {user?.name || user?.email}
                </span>
                <Button variant="outline" size="sm" onClick={handleLogout}>
                  Logout
                </Button>
              </>
            ) : (
              <Button variant="outline" size="sm" asChild>
                <NavLink to="/login">Login</NavLink>
              </Button>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t py-4">
        <div className="container mx-auto text-center text-sm text-gray-500">
          Militech HR Software © {new Date().getFullYear()}
        </div>
      </footer>
      
      <Toaster />
    </div>
  );
} 